import { Form } from "antd";
import { StyledInput, StyledSelect } from "./styled";
import { ArrowDown } from "../icons/ArrowDown";

interface EditableCellProps extends React.HTMLAttributes<HTMLElement> {
  editing: boolean;
  dataIndex: string;
  index: number;
  type: string;
  inputType: "input" | "select";
  children: React.ReactNode;
  placeholder: string;
}

export const EditableCell: React.FC<EditableCellProps> = ({
  editing,
  dataIndex,
  placeholder,
  type,
  inputType,
  children,
  ...restProps
}) => {
  const options = [
    { label: "КЖ", value: "КЖ" },
    { label: "ОВ", value: "ОВ" },
    { label: "ХС", value: "ХС" },
    { label: "СГП", value: "СГП" },
  ];

  const inputNode =
    inputType === "select" ? (
      <StyledSelect
        style={{ color: "#4a5368" }}
        mode="multiple"
        allowClear={false}
        suffixIcon={
          <div className="arrow-icon">
            <ArrowDown />
          </div>
        }
        placeholder="Раздел РД"
        onChange={() => {}}
        options={options}
      />
    ) : (
      <StyledInput type={type} placeholder={placeholder} />
    );

  return (
    <td {...restProps}>
      {editing ? <Form.Item name={dataIndex}>{inputNode}</Form.Item> : children}
    </td>
  );
};
